import { Box } from '@shape-ds/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './NotificationsFormType.scss';
import { NotificationsFormTypeOptions } from './NotificationsFormTypeItem/useGetNotificationsOptions';
import NotificationFormTypeItem from './NotificationsFormTypeItem/NotificationFormTypeItem';

const NotificationsFormType: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box className="notifications-manager-form-content">
      <h3 className="notifications-manager-title">
        {t('components:notifications_manager.notification_type.title')}
      </h3>
      {NotificationsFormTypeOptions.map((option) => (
        <NotificationFormTypeItem key={option.name} notificationType={option} />
      ))}
    </Box>
  );
};

export default NotificationsFormType;
